import React from "react";

import { DrawerProps, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

import { NotInterestedRounded } from "@mui/icons-material";

import { DynamicDrawer } from "../../Drawer/DynamicDrawer";
import { ExpandableAllergen } from "../../ExpandableAllergen/ExpandableAllergen";
import CloseIcon from "../../Icons/Close";

export type PossibleAllergensDrawerProps = DrawerProps & {
  open: boolean;
  onClose: () => void;
  containerRef?: React.RefObject<HTMLDivElement>;
};

export const DishDisclaimerDrawer = ({
  open,
  onClose,
  containerRef,
}: PossibleAllergensDrawerProps) => {
  const { palette } = useTheme();
  return (
    <DynamicDrawer
      ref={containerRef}
      drawerType="small"
      open={open}
      onClose={onClose}
      Header={
        <Stack alignItems="center" gap={1}>
          <NotInterestedRounded
            sx={{ color: palette.oscar.light.icon.danger }}
          />
          <Typography variant="headingRLight" textAlign="center">
            Why some dishes may
            <br />
            contain allergens:
          </Typography>
        </Stack>
      }
      Footer={
        <CloseIcon
          color={palette.oscar.light.icon.black}
          style={{ cursor: "pointer" }}
          height={32}
          width={32}
          onClick={onClose}
        />
      }
    >
      <Stack overflow="auto">
        <Typography variant="h6" fontWeight="bold">
          Cross contamination
        </Typography>

        <Stack
          marginTop={2}
          marginBottom={4}
          sx={{
            backgroundColor: palette.grey[200],
            gap: 1.5,
            padding: 2,
          }}
        >
          <Typography>Coconut, Gluten</Typography>
          <Typography>
            These allergens have been added by the chef, due to potential cross
            contamination that may occur inn the making/preparation of the food
          </Typography>
        </Stack>

        <Typography variant="h6" fontWeight="bold">
          Other may contains
        </Typography>

        <Stack gap={1.5} marginTop={2}>
          <ExpandableAllergen
            expanded
            allergen={{
              title: "Flavoring and additives: Undisclosed ingredients",
              ingredients: ["Wheat", "Barley", "Rye"],
              description:
                "Flavourings and additives may include undisclosed ingredients. Please consult the manufacturer direct for further information",
            }}
          />
          <ExpandableAllergen
            allergen={{
              title: "Egg",
              ingredients: ["Wheat", "Barley", "Rye"],
              description: "Egg is bad for you!!!",
            }}
          />
          <ExpandableAllergen
            allergen={{
              title: "Fish",
              ingredients: ["Wheat", "Barley", "Rye"],
              description: "Fish is bad for you!!!",
            }}
          />
          <ExpandableAllergen
            allergen={{
              title: "Dairy",
              ingredients: ["Wheat", "Barley", "Rye"],
              description: "Dairy is bad for you!!!",
            }}
          />
        </Stack>
      </Stack>
    </DynamicDrawer>
  );
};
